module.exports = __webpack_public_path__ + "static/media/ad2.4aa1eba1.png";